export const DEFAULT_CANDIDATE_PROFILE = "DEFAULT_CANDIDATE_PROFILE";
export const CAMPAIGN_CANDIDATE_PROFILE = "CAMPAIGN_CANDIDATE_PROFILE";
